import { ContainerLayout } from './Detail/Container'
import { DetailLayout } from './Detail/DetailPage'

export const Layout = {
  Detail: DetailLayout,
  Container: ContainerLayout
}